import React, { useEffect, useMemo, useState } from 'react';
import { PostHogProvider } from 'posthog-js/react';
import CookieConsent from './CookieConsent';

const CONSENT_KEY = 'analytics_consent'; // values: 'granted' | 'denied'

function getStoredConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

function setStoredConsent(val) {
  try {
    localStorage.setItem(CONSENT_KEY, val);
  } catch {
    /* no-op */
  }
}

export default function AnalyticsGate({ children }) {
  const [consent, setConsent] = useState(() => getStoredConsent());

  const accept = () => {
    setStoredConsent('granted');
    setConsent('granted');
  };
  const decline = () => {
    setStoredConsent('denied');
    setConsent('denied');
  };

  const posthogOptions = useMemo(() => ({
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    defaults: '2025-05-24',
    capture_exceptions: true,
    debug: process.env.NODE_ENV === 'development',
    // Respect Do Not Track in addition to consent
    respect_dnt: true,
    // Don't load if user denied (extra safety)
    loaded: (ph) => {
      if (consent !== 'granted') {
        ph.opt_out_capturing();
      }
    },
  }), [consent]);

  // If undecided, show banner and do not load PostHog
  if (consent !== 'granted') {
    return (
      <>
        {children}
        {consent !== 'denied' && (
          <CookieConsent onAccept={accept} onDecline={decline} />
        )}
      </>
    );
  }

  // Consent granted: render PostHogProvider
  return (
    <PostHogProvider apiKey={process.env.REACT_APP_POSTHOG_KEY} options={posthogOptions}>
      {children}
    </PostHogProvider>
  );
}
